import React from "react"

const MyAccountSettingsContext = React.createContext({})

const { Provider, Consumer } = MyAccountSettingsContext

export { Provider, Consumer, MyAccountSettingsContext }
